import React, { useEffect, useRef } from "react";
import { Navbar, Footer } from "../components";
import { useLocation } from "react-router-dom";
import "../styles/PoliciesPage.css";


const PoliciesPage = () => {

    const termsRef    = useRef(null);
    const privacyRef  = useRef(null);
    const refundRef   = useRef(null);
    const shippingRef = useRef(null);

    const scrollToSection = (ref) => {
        if (!ref.current) return;
        const navbarHeight = 100;
        const y =
            ref.current.getBoundingClientRect().top +
            window.pageYOffset -
            navbarHeight;
        window.scrollTo({ top: y, behavior: "smooth" });
    };

    const location = useLocation();

    useEffect(() => {
        const hash = location.hash;
        if (hash === "#terms")    scrollToSection(termsRef);
        if (hash === "#privacy")  scrollToSection(privacyRef);
        if (hash === "#refund")   scrollToSection(refundRef);
        if (hash === "#shipping") scrollToSection(shippingRef);
    }, [location]);


    return (
        <>
            <Navbar />

            <div className="container policies-page my-4 py-3">

                {/* ── Page Header ── */}
                <div className="policies-header">
                    <h1 className="policies-header__title">Policies &amp; Legal Information</h1>
                    <p className="policies-header__subtitle">
                        Everything you need to know about how we operate
                    </p>
                    <hr className="policies-header__divider" />
                </div>

                {/* ── Two-column layout ── */}
                <div className="policies-layout">

                    {/* ── Sidebar ── */}
                    <aside className="policies-sidebar">
                        <p className="policies-sidebar__label">Policies</p>
                        <nav className="policies-sidebar__nav">

                            <button
                                onClick={() => scrollToSection(termsRef)}
                                className="policies-sidebar__btn"
                            >
                                <span className="policies-sidebar__btn-icon">📜</span>
                                Terms &amp; Conditions
                            </button>

                            <button
                                onClick={() => scrollToSection(privacyRef)}
                                className="policies-sidebar__btn"
                            >
                                <span className="policies-sidebar__btn-icon">🔐</span>
                                Privacy Policy
                            </button>

                            <button
                                onClick={() => scrollToSection(refundRef)}
                                className="policies-sidebar__btn"
                            >
                                <span className="policies-sidebar__btn-icon">↩️</span>
                                Return &amp; Refund Policy
                            </button>

                            <button
                                onClick={() => scrollToSection(shippingRef)}
                                className="policies-sidebar__btn"
                            >
                                <span className="policies-sidebar__btn-icon">🚚</span>
                                Shipping &amp; Payment
                            </button>

                        </nav>
                    </aside>

                    {/* ── Main Content ── */}
                    <main className="policies-content">

                        {/* ════ TERMS & CONDITIONS ════ */}
                        <section ref={termsRef} className="policy-section">
                            <div className="policy-section__header">
                                <span className="policy-section__icon">📜</span>
                                <h3 className="policy-section__title">Terms &amp; Conditions</h3>
                                <span className="policy-section__updated">Last Updated: 2025</span>
                            </div>

                            <p>
                                Welcome to <strong>Saranya Bio tech Nursery</strong> ("Company", "we", "our", "us").
                                These Terms &amp; Conditions ("Terms") govern your use of our website
                                <strong> www.saranyabiotechnursery.com</strong> ("Website") and its related services.
                            </p>
                            <p>
                                By accessing or placing an order on this Website, you agree to be bound by these Terms.
                                If you do not agree, please do not use our Website.
                            </p>

                            <h5 className="policy-subsection-title">1. General Use</h5>
                            <ul className="policy-list">
                                <li>You must be at least 18 years old to purchase from our Website.</li>
                                <li>We sell natural products and related items.</li>
                                <li>We may modify, update, discontinue, or restrict Website access anytime.</li>
                            </ul>

                            <h5 className="policy-subsection-title">2. Product Information</h5>
                            <p>
                                We make every effort to display accurate product descriptions but do not guarantee
                                error-free content. Packaging and colors may vary slightly.
                            </p>

                            <h5 className="policy-subsection-title">3. Orders &amp; Acceptance</h5>
                            <p>Placing an order does not guarantee acceptance. Orders are accepted only after successful Razorpay payment.</p>
                            <p>We may cancel orders due to:</p>
                            <ul className="policy-list">
                                <li>Payment failure</li>
                                <li>Incorrect information</li>
                                <li>Product unavailability</li>
                                <li>Suspicious activity</li>
                            </ul>

                            <h5 className="policy-subsection-title">4. Pricing</h5>
                            <ul className="policy-list">
                                <li>Prices are listed in INR and may change without notice.</li>
                                <li>The checkout price is final.</li>
                            </ul>

                            <h5 className="policy-subsection-title">5. Payments</h5>
                            <p>We accept <strong>online payment only</strong> via Razorpay:</p>
                            <div className="payment-methods">
                                <span className="payment-chip">💳 Debit Cards</span>
                                <span className="payment-chip">💳 Credit Cards</span>
                                <span className="payment-chip">📱 UPI</span>
                                <span className="payment-chip">🏦 Net Banking</span>
                                <span className="payment-chip">👜 Wallets</span>
                            </div>
                            <div className="policy-callout policy-callout--warning">
                                <span className="policy-callout__icon">❌</span>
                                Cash on Delivery (COD) is <strong>NOT available</strong>.
                            </div>
                            <p>
                                Payments are securely processed by Razorpay. You agree to their Terms &amp; Privacy Policy.
                            </p>

                            <h5 className="policy-subsection-title">6. Shipping</h5>
                            <p>Shipping timelines appear in the Shipping &amp; Payment Policy section below.</p>

                            <h5 className="policy-subsection-title">7. Cancellations / Returns / Refunds</h5>
                            <div className="policy-callout policy-callout--warning">
                                <span className="policy-callout__icon">❌</span>
                                We do <strong>NOT</strong> accept cancellations, returns, or refunds.
                            </div>

                            <h5 className="policy-subsection-title">8. Intellectual Property</h5>
                            <p>
                                All content on this Website is owned by Saranya Bio tech Nursery. Unauthorized use is prohibited.
                            </p>

                            <h5 className="policy-subsection-title">9. Prohibited Activities</h5>
                            <ul className="policy-list">
                                <li>Misuse of Website</li>
                                <li>Uploading harmful files</li>
                                <li>Unauthorized access attempts</li>
                                <li>Illegal activities</li>
                            </ul>

                            <h5 className="policy-subsection-title">10. Limitation of Liability</h5>
                            <p>
                                We are not responsible for courier delays, misuse of products, technical issues,
                                or indirect losses. Use of the Website is at your own risk.
                            </p>

                            <h5 className="policy-subsection-title">11. Indemnification</h5>
                            <p>
                                You agree to indemnify Saranya Bio tech Nursery against any claims arising from misuse of our services.
                            </p>

                            <h5 className="policy-subsection-title">12. Governing Law</h5>
                            <p>These Terms follow Indian Law. Disputes fall under Tamil Nadu jurisdiction.</p>

                            <h5 className="policy-subsection-title">13. Contact Info</h5>
                            <div className="policy-contact">
                                <p className="policy-contact__name">Saranya Bio tech Nursery</p>
                                <p className="policy-contact__row">
                                    📍 17/53, Periyakadu, Siviyarpalayam, N.K. Valasu (PO), Kangeyam — 638701
                                </p>
                                <p className="policy-contact__row">
                                    ✉️&nbsp;
                                    <a href="mailto:Saranyabiotechnursery@gmail.com">saranyabiotechnursery@gmail.com</a>
                                </p>
                                <p className="policy-contact__row">
                                    📞&nbsp;
                                    <a href="tel:+919677831426">+91 96778 31426</a>
                                </p>
                            </div>
                        </section>


                        {/* ════ PRIVACY POLICY ════ */}
                        <section ref={privacyRef} className="policy-section">
                            <div className="policy-section__header">
                                <span className="policy-section__icon">🔐</span>
                                <h3 className="policy-section__title">Privacy Policy</h3>
                                <span className="policy-section__updated">Last Updated: 2026</span>
                            </div>

                            <p>
                                We value your privacy. This Policy explains how we collect, use, store, and protect your
                                data when visiting <strong>www.saranyabiotechnursery.com</strong>.
                            </p>

                            <h5 className="policy-subsection-title">1. Information We Collect</h5>
                            <p><strong>Personal Information</strong></p>
                            <ul className="policy-list">
                                <li>Name</li>
                                <li>Address</li>
                                <li>Email</li>
                                <li>Phone number</li>
                                <li>Payment details (processed securely by Razorpay)</li>
                            </ul>
                            <p><strong>Non-Personal Information</strong></p>
                            <ul className="policy-list">
                                <li>Browser details</li>
                                <li>Device info</li>
                                <li>IP address</li>
                                <li>Cookies &amp; usage patterns</li>
                            </ul>

                            <h5 className="policy-subsection-title">2. How We Use Your Information</h5>
                            <ul className="policy-list">
                                <li>To process and deliver orders</li>
                                <li>To provide customer support</li>
                                <li>To prevent fraud</li>
                                <li>To improve our website</li>
                                <li>To send essential updates</li>
                            </ul>
                            <div className="policy-callout policy-callout--success">
                                <span className="policy-callout__icon">✅</span>
                                We do <strong>NOT</strong> sell your data.
                            </div>

                            <h5 className="policy-subsection-title">3. Payments via Razorpay</h5>
                            <p>Your payment details are not stored by us. Razorpay handles all financial data.</p>

                            <h5 className="policy-subsection-title">4. Cookies</h5>
                            <p>Cookies help improve functionality and analytics.</p>

                            <h5 className="policy-subsection-title">5. Information Sharing</h5>
                            <ul className="policy-list">
                                <li>Courier partners</li>
                                <li>Razorpay</li>
                                <li>Legal authorities (when required)</li>
                            </ul>

                            <h5 className="policy-subsection-title">6. Data Security</h5>
                            <p>
                                We use industry-level protection but cannot guarantee 100% safety due to internet risks.
                            </p>

                            <h5 className="policy-subsection-title">7. Data Retention</h5>
                            <p>We retain your data only as required for legal, transactional, and service reasons.</p>

                            <h5 className="policy-subsection-title">8. Your Rights</h5>
                            <ul className="policy-list">
                                <li>Request data correction</li>
                                <li>Request deletion (where legally possible)</li>
                                <li>Opt-out of emails</li>
                            </ul>

                            <h5 className="policy-subsection-title">9. External Links</h5>
                            <p>We are not responsible for content or privacy practices of third-party websites.</p>

                            <h5 className="policy-subsection-title">10. Changes</h5>
                            <p>We may update this policy anytime. Updates appear on this page.</p>

                            <h5 className="policy-subsection-title">11. Grievance Officer</h5>
                            <div className="policy-contact">
                                <p className="policy-contact__row">
                                    ✉️&nbsp;
                                    <a href="mailto:saranyabiotechnursery@gmail.com">saranyabiotechnursery@gmail.com</a>
                                </p>
                                <p className="policy-contact__row">
                                    📞&nbsp;
                                    <a href="tel:+919677831426">+91 96778 31426</a>
                                </p>
                            </div>
                        </section>


                        {/* ════ RETURN & REFUND POLICY ════ */}
                        <section ref={refundRef} className="policy-section">
                            <div className="policy-section__header">
                                <span className="policy-section__icon">↩️</span>
                                <h3 className="policy-section__title">Return &amp; Refund Policy</h3>
                                <span className="policy-section__updated">Last Updated: 2026</span>
                            </div>

                            <p>
                                At <strong>Saranya Bio tech Nursery</strong>, we take great care in preparing and delivering
                                100% natural, fresh, and handmade products. Due to the nature of our products,
                                we follow a strict <strong>no return, no exchange, and no refund policy</strong>.
                            </p>

                            <h5 className="policy-subsection-title">No Return or Exchange Policy</h5>
                            <p>
                                All products sold on <strong>www.saranyabiotechnursery.com</strong> are
                                <strong> non-returnable and non-exchangeable</strong>. Once an order has been delivered,
                                we cannot accept returns or exchanges, as we cannot guarantee product quality,
                                safety, or hygiene after delivery.
                            </p>

                            <h5 className="policy-subsection-title">Damaged, Defective, or Wrong Item Received</h5>
                            <p>
                                In the rare event that you receive a product that is damaged, leaked, defective,
                                or incorrect, please contact us within <strong>24 hours of delivery</strong>:
                            </p>
                            <div className="policy-callout policy-callout--info">
                                <span className="policy-callout__icon">✉️</span>
                                Email us at&nbsp;
                                <a href="mailto:saranyabiotechnursery@gmail.com">
                                    <strong>saranyabiotechnursery@gmail.com</strong>
                                </a>
                            </div>
                            <p>Please include the following in your email:</p>
                            <ul className="policy-list">
                                <li>Your Order ID</li>
                                <li>Clear photos of the product and outer packaging</li>
                                <li>Unboxing video (if available)</li>
                            </ul>
                            <p>After verification of the issue, we may:</p>
                            <ul className="policy-list">
                                <li>Arrange a replacement for the same product, or</li>
                                <li>Initiate a refund if a replacement is unavailable</li>
                            </ul>

                            <h5 className="policy-subsection-title">Non-Returnable Items</h5>
                            <p>The following items are strictly non-returnable and non-refundable:</p>
                            <ul className="policy-list">
                                <li>All edible products, natural powders, oils, soaps, and personal care items</li>
                                <li>Opened, unsealed, or used products</li>
                                <li>Items returned without prior communication or approval</li>
                                <li>Products damaged due to improper storage or handling by the customer</li>
                            </ul>

                            <h5 className="policy-subsection-title">Order Cancellation</h5>
                            <p>
                                Orders can be cancelled only within <strong>1 hour of placing the order</strong>,
                                provided the order has not yet been packed or shipped.
                            </p>
                            <div className="policy-callout policy-callout--info">
                                <span className="policy-callout__icon">📧</span>
                                To cancel, email your Order ID immediately to&nbsp;
                                <a href="mailto:saranyabiotechnursery@gmail.com">
                                    <strong>saranyabiotechnursery@gmail.com</strong>
                                </a>
                            </div>
                            <p>
                                Once an order has been processed or shipped, it cannot be cancelled, returned, or refunded.
                            </p>
                        </section>


                        {/* ════ SHIPPING & PAYMENT POLICY ════ */}
                        <section ref={shippingRef} className="policy-section">
                            <div className="policy-section__header">
                                <span className="policy-section__icon">🚚</span>
                                <h3 className="policy-section__title">Shipping &amp; Payment Policy</h3>
                                <span className="policy-section__updated">Last Updated: 2026</span>
                            </div>

                            <h5 className="policy-subsection-title">1. Shipping Timeline</h5>
                            <p>
                                Orders are dispatched within <strong>24–48 hours</strong>.
                                Delivery takes <strong>2–7 business days</strong> depending on your location.
                            </p>

                            <h5 className="policy-subsection-title">2. Delivery Coverage</h5>
                            <p>We ship PAN-India via trusted courier partners.</p>

                            <h5 className="policy-subsection-title">3. Shipping Charges</h5>
                            <p>Charges are shown at checkout. Some products may include free shipping.</p>

                            <h5 className="policy-subsection-title">4. Order Tracking</h5>
                            <p>You will receive order updates along with a tracking link once dispatched.</p>

                            <h5 className="policy-subsection-title">5. Delivery Confirmation</h5>
                            <p>
                                A signature or OTP may be required upon delivery.
                                After confirmation, responsibility for the product transfers to you.
                            </p>

                            <h5 className="policy-subsection-title">6. Payment Methods</h5>
                            <p>We accept the following via <strong>Razorpay</strong>:</p>
                            <div className="payment-methods">
                                <span className="payment-chip">📱 UPI</span>
                                <span className="payment-chip">💳 Debit Cards</span>
                            </div>
                            <div className="policy-callout policy-callout--warning">
                                <span className="policy-callout__icon">❌</span>
                                Cash on Delivery is <strong>NOT available</strong>.
                            </div>
                        </section>

                    </main>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default PoliciesPage;